import React from 'react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function DeckPreview({ deck, deckId, previewImages, activeSlide }) {
  if (!deck) return <div className="preview-empty">Generate a deck to see preview</div>;

  const allSlides = [
    { title: deck.title, layout: 'cover', subtitle: deck.subtitle, bullets: [] },
    { title: 'Executive Summary', layout: 'content', bullets: [deck.executive_summary], speaker_notes: deck.executive_summary_notes || '' },
    ...(deck.slides || [])
  ];

  const slide = allSlides[activeSlide] || allSlides[0];
  const hasImage = previewImages && previewImages[activeSlide];

  if (hasImage) {
    return (
      <div className="preview-main">
        <img
          src={`${API}/preview/${deckId}/${previewImages[activeSlide]}`}
          alt={`Slide ${activeSlide + 1}`}
          className="preview-main__img"
        />
        {slide.speaker_notes && (
          <div className="preview-main__notes">
            <strong>Notes:</strong> {slide.speaker_notes}
          </div>
        )}
      </div>
    );
  }

  // JSON card fallback
  return (
    <div className="preview-main">
      <div className={`slide-card slide-card--${slide.layout || 'content'}`}>
        <div className="slide-card__number">Slide {activeSlide + 1}</div>
        <h2 className="slide-card__title">{slide.title}</h2>
        {slide.subtitle && <p className="slide-card__subtitle">{slide.subtitle}</p>}
        {slide.metric && <div className="slide-card__metric">{slide.metric}</div>}
        {slide.label && <p className="slide-card__label">{slide.label}</p>}
        {slide.quote && <blockquote className="slide-card__quote">"{slide.quote}"</blockquote>}
        {slide.bullets && slide.bullets.length > 0 && (
          <ul className="slide-card__bullets">
            {slide.bullets.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
        )}
      </div>
      {slide.speaker_notes && (
        <div className="preview-main__notes">
          <strong>Notes:</strong> {slide.speaker_notes}
        </div>
      )}
    </div>
  );
}
